<template>
    <div class="my-3">
        <a href="javascript:void(0);" @click="visible = true">Mostra {{ title }}</a>

        <Dialog :visible.sync="visible" modal dismissableMask :style="{width: '90vw', maxWidth:'900px'}">
            <template #header>
		        <h3>{{ title }}</h3>
	        </template>
            <div v-html="content"></div>
        </Dialog>

    </div>
</template>

<script>
import Dialog from 'primevue/dialog';

export default {
    props: [
        'title',
        'content',
    ],
    components: {
        Dialog,
    },
    data() {
        return {
            visible: false,
        };
    },

}
</script>

<style scoped>

</style>
